import { LoadingOutlined } from '@ant-design/icons';
import { unwrapResult } from '@reduxjs/toolkit';
import { Form, Spin } from 'antd';
import { random, sortBy } from 'lodash';
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Persistor } from "../..";
import { NavContext } from '../../App';
import signalRService from '../../GlobalComponents/Utility/SignalRConnection';
import { getAttachementList, getNbreAttachementNotSeen } from "../../ReduxTLK/features/Attachement/AttachementSlice";
import { fetchChaines } from "../../ReduxTLK/features/Chaines/ChaineSlice";
import { getMessages, getNbrMessagesNonLus } from "../../ReduxTLK/features/Chat/ChatSlice";
import { setPaginationModelSAVTA } from "../../ReduxTLK/features/Pagination/PaginationsSlice";
import { fetchPventes } from "../../ReduxTLK/features/Pointdeventes/PointdeventeSlice";
import { fetchTicketById } from "../../ReduxTLK/features/SAV/TicketSlice";
import { addTab, removeTabById, setLastActiveTab } from "../../ReduxTLK/features/Tabs/TabsSlice";
import { fetchUsersAgentSAV } from "../../ReduxTLK/features/User/UserSlice";
import ViewSAVTicket from "../../Pages/SAV/TicketDetails/View/ViewSAVTicket";
import ExecuteTicketInsideUpdateModal from '../modals/ExecuteTicketInsideUpdateModal';
import MettreEnAttenteTicketModal from "../modals/MettreEnAttenteTicketModal";
import ResolveTicketModal from "../modals/ResolveTicketModal";
import EditSAVTicketHeader from "./EditSAVTicketHeader";
import SAVIcon from "../../GlobalComponents/IconComponents/SAVIcon";
import { canChangeTeam, getTeam } from "../../utils/escaladeUtils";
import EditSAVTicketTabs from './EditSAVTicketTabs/EditSAVTicketTabs';

// ─── Helper ──────────────────────────────────────────────────────
const getActiveInternalStatus = (internalStatus = []) => {
  if (!internalStatus?.length) return null;
  return [...internalStatus].reverse().find(s => s.dateFin == null) ?? null;
};

// ═════════════════════════════════════════════════════════════════
// COMPOSANT PRINCIPAL
// ═════════════════════════════════════════════════════════════════
export default function EditSAVTicket({ id, viewOnly }) {
  const context = React.useContext(NavContext);
  const [nbreAttachementsNonLus, setNbreAttachementsNonLus] = useState(null);

  useEffect(() => {
    if (context.roomId === id)
      setMessagesList(prev => [...prev, {
        id: random(),
        attachement: context.receivedMessage?.attachement,
        contenu:     context.receivedMessage?.contenu,
        date:        context.receivedMessage?.dateEnvoie,
        messageUpdateStatut: {
          action: {
            userFirstName: context?.receivedMessage?.messageUpdateStatut?.action?.userFirstName,
            idTicket:      context?.receivedMessage?.messageUpdateStatut?.action?.idTicket,
            firstStatuts:  context?.receivedMessage?.messageUpdateStatut?.action?.firstStatuts,
            secondStatuts: context?.receivedMessage?.messageUpdateStatut?.action?.secondStatuts,
          },
          cause: context?.receivedMessage?.messageUpdateStatut?.cause,
          note:  context?.receivedMessage?.messageUpdateStatut?.note,
        },
        sender: { id: context.receivedMessage?.idSender, nom: context.receivedMessage?.name },
      }]);
    signalRService.onJoinRoom(id);
    signalRService.onReceiveMessage(msg => {
      context.setReceivedMessage(msg);
      context.setRoomId(id);
      context.setIsInRoom(true);
    });
  }, [context.receivedMessage]);

  useEffect(() => {
    if (context.roomId === id) {
      dispatch(getNbrMessagesNonLus({ idTicket: id, page: 1, pageSize: 1000 })).then(res => {
        setNbreMessagesNonLus(!openChatBox ? res?.payload?.data?.data?.result : 0);
      });
    }
    if (context.receivedMessage?.attachement?.id != null) {
      setNbreAttachementsNonLus(n => (n ?? 0) + 1);
    }
  }, [context.receivedMessage]);

  const [dirty,         setDirty]        = useState(false);
  const [loading,       setLoading]      = useState(true);
  const [ticketDetails, setTicket]       = useState();
  const [messagesList,  setMessagesList] = useState([]);
  const [nbreMessagesNonLus, setNbreMessagesNonLus] = useState([]);
  const [reloadAfterNotifClick, setReloadAfterNotifClick] = useState(context.tabToBeReloadedNotif);
  const formRef  = useRef();
  const [form]   = Form.useForm();
  const dispatch = useDispatch();
  const { register, control, handleSubmit, formState: { errors } } = useForm({});

  useEffect(() => { setReloadAfterNotifClick(context.tabToBeReloadedNotif); }, [context.tabToBeReloadedNotif]);
  useEffect(() => {
    if (reloadAfterNotifClick && parseInt(context.tabToBeReloadedNotif) === parseInt(id)) {
      setValue(1); context.setTabToBeReloadedNotif();
    }
  }, [reloadAfterNotifClick]);

  useEffect(() => {
    if (parseInt(context.tabToBeReloadedAttachement) === parseInt(id)) {
      dispatch(getNbreAttachementNotSeen(id)).then(unwrapResult).then(res => {
        setNbreAttachementsNonLus(res.data.data.result);
      }).then(() => {
        if (value === 2) {
          dispatch(getAttachementList({ pageSize: 7, page: 1, nbPage: 0, idTicket: id }))
            .then(unwrapResult).then(res => {
              setAttachmentList(res?.data?.data?.result);
              const pg = { pageSize: res?.data?.data?.pagination?.pageSize, page: res?.data?.data?.pagination?.currentPage, nbPage: res?.data?.data?.pagination?.nbPage, idTicket: ticketDetails?.id };
              setPaginationModelCustom(pg);
              dispatch(setPaginationModelSAVTA({ page: res?.data?.pagination?.currentPage, pageSize: res?.data?.pagination?.pageSize, nbPage: res?.data?.pagination?.nbPage, idTicket: ticketDetails?.id }));
              Persistor.persist();
            });
        }
      });
    }
  }, [context.tabToBeReloadedAttachement]);

  const applyTicketStates = (res) => {
    setTicket(res);
    setPageTitle(`${symbol}${res?.id}`);
    setCanExecute(false); setCanExecuteOpen(false);
    setNewTicket(false);  setEnCours(false); setResolved(false);
    switch (res?.statut) {
      case 0: setNewTicket(true);  break;
      case 1: setCanExecute(true); break;
      case 2: setEnCours(true);    break;
      case 3: setResolved(true);   break;
      case 4: setCanExecute(true); break;
      default: break;
    }
  };

  useEffect(() => {
    if (!context.tabToBeReloaded || parseInt(context.tabToBeReloaded) !== parseInt(id)) return;
    setValue(1);
    dispatch(fetchTicketById(id)).then(unwrapResult).then(res => {
      if (res?.statut === 6) {
        const cId = 'SAV_Ticket_' + res?.id;
        const title = '#' + res?.id;
        const updatedTabs = context.tabs.filter(t => t.identifier !== res?.id);
        dispatch(removeTabById(cId));
        context.setTabs([...updatedTabs, { id: cId, label: title, identifier: res?.id, component: <ViewSAVTicket id={res?.id} />, closeable: true, icon: <SAVIcon /> }]);
        dispatch(addTab({ module: 'SAV', action: 'View', identifier: res?.id, id: cId, label: title }));
        Persistor.persist();
        context.setActiveTab(cId);
        dispatch(setLastActiveTab(cId));
      } else {
        applyTicketStates(res);
        context.setTabToBeReloaded();
      }
    });
  }, [context.tabToBeReloaded]);

  useEffect(() => { dispatch(fetchUsersAgentSAV()); dispatch(fetchChaines()); }, []);

  const symbol = '#';
  const [pageTitle,     setPageTitle]     = useState();
  const [etablissement, setEtablissement] = useState();

  const fetchMessages = async () => {
    if (!ticketDetails?.id) return;
    try {
      dispatch(getMessages({ idTicket: ticketDetails.id, page: 1, pageSize: 1000 }))
        .then(unwrapResult).then(res => setMessagesList(sortBy(res.data?.data?.result, 'date')));
    } catch {}
  };

  const fetchData = () => {
    dispatch(fetchTicketById(ticketDetails?.id ?? id)).then(unwrapResult).then(res => {
      applyTicketStates(res); setLoading(false);
    });
  };

  useEffect(() => {
    setTimeout(() => {
      dispatch(fetchTicketById(id)).then(unwrapResult).then(res => {
        applyTicketStates(res); setLoading(false);
        setEtablissement(res?.chaine?.id);
        dispatch(getNbreAttachementNotSeen(id)).then(unwrapResult).then(r => setNbreAttachementsNonLus(r.data.data.result));
        const data = { idTicket: res?.id, page: 1, pageSize: 1000 };
        try {
          dispatch(getNbrMessagesNonLus(data))
            .then(r => setNbreMessagesNonLus(!openChatBox ? r?.payload?.data?.data?.result : 0))
            .then(() => dispatch(getMessages(data)).then(unwrapResult).then(r => setMessagesList(sortBy(r.data?.data?.result, 'date'))));
        } catch {}
        form.setFieldsValue({
          etablissement: res?.idChaine, pointDeVente: res?.idPv, machine: res?.machine,
          type: res?.type, sujet: res?.sujet, priorite: res?.priorite,
          intervenant: `${res?.intervenantFirstname ?? ''} ${res?.intervenantLastname ?? ''}`.trim(),
          impact: res?.impact, idAssignee: res?.idAssigne,
          telephone: res?.intervenantPhone, description: res?.description,
        });
        dispatch(fetchPventes(res?.idChaine));
      });
    }, 1000);
    return () => setNbreAttachementsNonLus(0);
  }, []);

  useEffect(() => { if (etablissement != null) dispatch(fetchPventes(etablissement)); }, [etablissement]);

  const [requiredFieldsSet, setRequiredFieldsSet] = useState(false);
  useEffect(() => {
    setRequiredFieldsSet(
      ticketDetails?.idChaine != null && ticketDetails?.idPv != null &&
      ticketDetails?.machine  != null && ticketDetails?.type != null &&
      ticketDetails?.sujet?.trim() !== '' && ticketDetails?.description?.trim() !== ''
    );
  }, [ticketDetails]);

  const handleCheckRequiredFields = async (form) => {
    try {
      await form.validateFields(['etablissement', 'pointDeVente', 'machine', 'type', 'sujet', 'description', 'priorite', 'idAssignee']);
      setRequiredFieldsSet(true);
    } catch {}
  };

  const agentsSAV = useSelector(s => s.user.agentsSAV);
  const [openChatBox, setOpenChatBox] = useState(false);

  const [canExecute,     setCanExecute]     = useState(false);
  const [canExecuteOpen, setCanExecuteOpen] = useState(false);
  const [enCours,        setEnCours]        = useState(false);
  const [newTicket,      setNewTicket]      = useState(false);
  const [resolved,       setResolved]       = useState(false);
  const [openModalExecute, setOpenModalExecute] = useState(false);
  const [openModalSuspend, setOpenModalSuspend] = useState(false);
  const [openModalResolve, setOpenModalResolve] = useState(false);

  // ── Escalade — dérivé de ticketDetails.internalStatus ─────────
  const activeInternalStatus = getActiveInternalStatus(ticketDetails?.internalStatus);
  const isEscaladed          = activeInternalStatus !== null;

  const validateAndOpen = async (openFn) => {
    setValue(1);
    try {
      await new Promise(r => setTimeout(r, 1000));
      formRef.current.validateFields()
        .then(values => { if (dirty) formRef.current.submit(values); openFn(); })
        .catch(() => {});
    } catch {}
  };

  const handleExecuteOpen = () => validateAndOpen(() => { setOpenModalResolve(false); setOpenModalExecute(true);  setOpenModalSuspend(false); });
  const handleExecute     = () => validateAndOpen(() => { setOpenModalResolve(false); setOpenModalExecute(true);  setOpenModalSuspend(false); });
  const handleSuspend     = () => validateAndOpen(() => { setOpenModalResolve(false); setOpenModalExecute(false); setOpenModalSuspend(true);  });
  const handleResolve     = () => validateAndOpen(() => { setOpenModalExecute(false); setOpenModalSuspend(false); setOpenModalResolve(true);  });

  const [value,      setValue]      = React.useState(1);
  const [background, setBackground] = useState('transparent');
  const changeTab = (_, newValue) => {
    if (value === 2) setNbreAttachementsNonLus(0);
    setValue(parseInt(newValue));
    setBackground(newValue === 2 ? 'white' : 'transparent');
  };

  const [attachmentList,        setAttachmentList]        = useState([]);
  const [paginationModelCustom, setPaginationModelCustom] = useState({ pageSize: 7, page: 1, nbPage: 0, idTicket: ticketDetails?.id });

  const fetchAttachments = async (pmc) => {
    if (value !== 2) return;
    dispatch(getAttachementList(pmc)).then(unwrapResult).then(res => {
      setAttachmentList(res?.data?.data?.result);
      const pg = { pageSize: res?.data?.data?.pagination?.pageSize, page: res?.data?.data?.pagination?.currentPage, nbPage: res?.data?.data?.pagination?.nbPage, idTicket: ticketDetails?.id };
      setPaginationModelCustom(pg);
      dispatch(setPaginationModelSAVTA({ page: res?.data?.pagination?.currentPage, pageSize: res?.data?.pagination?.pageSize, nbPage: res?.data?.pagination?.nbPage, idTicket: ticketDetails?.id }));
      Persistor.persist();
    });
  };

  const onEscaladeRefresh = () => { fetchData(); fetchMessages(); };

  return (
      <div>
        {loading ? (
          <center><Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} /></center>
        ) : (
          <>
            {/* ── Header card ─────────────────────────────────── */}
            <EditSAVTicketHeader
              ticketDetails={ticketDetails}
              newTicket={newTicket}
              canExecute={canExecute}
              enCours={enCours}
              isEscaladed={isEscaladed}
              activeInternalStatus={activeInternalStatus}
              onExecuteOpen={handleExecuteOpen}
              onExecute={handleExecute}
              onSuspend={handleSuspend}
              onResolve={handleResolve}
              onEscaladeRefresh={onEscaladeRefresh}
            />

            {/* ── Tabs ────────────────────────────────────────── */}
            <EditSAVTicketTabs
              value={value}
              onChangeTab={changeTab}
              ticketDetails={ticketDetails}
              formRef={formRef}
              setTicket={setTicket}
              setDirty={setDirty}
              onCheckRequiredFields={handleCheckRequiredFields}
              nbreAttachementsNonLus={nbreAttachementsNonLus}
              fetchAttachments={fetchAttachments}
              setAttachmentList={setAttachmentList}
              attachmentList={attachmentList}
              isEscaladed={isEscaladed}
              activeInternalStatus={activeInternalStatus}
              onEscaladeRefresh={onEscaladeRefresh}
              enCours={enCours}
              openChatBox={openChatBox}
              setOpenChatBox={setOpenChatBox}
              fetchMessages={fetchMessages}
              paginationModelCustom={paginationModelCustom}
              messagesList={messagesList}
              setMessagesList={setMessagesList}
              pageTitle={pageTitle}
              nbreMessagesNonLus={nbreMessagesNonLus}
              setNbreMessagesNonLus={setNbreMessagesNonLus}
              background={background}
              viewOnly={viewOnly}

            />

            {/* ── Modals existantes ───────────────────────────── */}
            <ExecuteTicketInsideUpdateModal fetchMessages={fetchMessages} openModal={openModalExecute} setOpenModal={setOpenModalExecute} openTicket={ticketDetails?.id} status={ticketDetails?.statut} fetchData={fetchData} newTicket={newTicket} />
            <MettreEnAttenteTicketModal openModal={openModalSuspend} setOpenModal={setOpenModalSuspend} openTicket={ticketDetails?.id} fetchData={fetchData} fetchMessages={fetchMessages} />
            <ResolveTicketModal openModal={openModalResolve} setOpenModal={setOpenModalResolve} openTicket={ticketDetails?.id} fetchData={fetchData} fetchMessages={fetchMessages} />
          </>
        )}
      </div>
   
  );
}
